import React, { Fragment } from 'react';
import { Image, Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer';
import logo from './logo.png';

const Invoice = ({ influencerName, charts, period }) => {
  const styles = StyleSheet.create({
    page: {
      fontSize: 11,
      paddingTop: 20,
      paddingBottom: 20,
      paddingLeft: 40,
      paddingRight: 40,
      lineHeight: 1.5,
      flexDirection: 'column',
    },

    spaceBetween: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      color: '#3E3E3E',
    },

    separator: {
      borderBottomWidth: 1,
      borderBottomColor: '#E2E2E2',
      marginVertical: 25, // space above and below
    },

    header: {
      flex: 1,
      flexDirection: 'column',
      marginLeft: '60',
    },

    titleContainer: { flexDirection: 'row', marginTop: 24, color: '#1C3D5D' },

    logo: { width: 90 },

    reportTitle: { fontSize: 16, fontWeight: 'bold' },

    reportSubTitle: { fontSize: 16, marginTop: 12 },

    theader: {
      marginTop: 20,
      fontSize: 10,
      fontWeight: 'bold',
      paddingVertical: 6,
      paddingLeft: 7,
      textAlign: 'center',
      flex: 1,
      justifyContent: 'center',
      backgroundColor: 'whitesmoke',
      minHeight: 24,
      color: '#000',
      borderColor: '#E2E2E2',
      borderTopWidth: 1,
      borderRightWidth: 1,
      borderBottomWidth: 1,
    },

    tbody: {
      fontSize: 9,
      paddingTop: 4,
      paddingLeft: 7,
      flex: 1,
      textAlign: 'center',
      borderColor: '#E2E2E2',
      borderRightWidth: 1,
      borderBottomWidth: 1,
      color: '#414342',
    },
  });

  const InvoiceTitle = () => (
    <View style={styles.titleContainer}>
      <Image style={styles.logo} src={logo} />
      <View style={styles.header}>
        <Text style={styles.reportTitle}>Report Influencer : {influencerName}</Text>
        <Text style={styles.reportSubTitle}>{`(Periode ${period.startDate} - ${period.endDate})`}</Text>
      </View>
    </View>
  );

  const LABEL = {
    total_redeem: 'Jumlah Redeem',
    total_click: 'Jumlah Click',
    total_usage: 'Jumlah Penggunaan',
  };

  const Chart = ({ image, type }) => (
    <View>
      <Text style={{ fontSize: 12, fontWeight: 'bold', color: '#093D5F' }}>{LABEL[type]}</Text>
      {image ? (
        <Image style={{ marginTop: 20 }} src={image} />
      ) : (
        <Text style={{ marginTop: 20, color: 'red' }}>Chart image not available</Text>
      )}
    </View>
  );

  const TableHead = ({ type }) => (
    <View style={{ width: '100%', flexDirection: 'row', marginTop: 20 }}>
      <View style={[styles.theader, { borderLeftWidth: 1 }]}>
        <Text>Tanggal</Text>
      </View>
      <View style={styles.theader}>
        <Text>{LABEL[type] || type}</Text>
      </View>
    </View>
  );

  const TableBody = (data) => (
    <>
      {data.map((item, index) => (
        <Fragment key={index}>
          {/* Force page break every 20 rows */}
          {index % 20 === 0 && index !== 0 && (
            <>
              {/* Add a page break */}
              <View break />

              {/* Repeat the table head on the new page */}
              <TableHead />
            </>
          )}

          {/* Table row */}
          <View style={{ width: '100%', flexDirection: 'row' }}>
            <View style={[styles.tbody, { borderLeftWidth: 1 }]}>
              <Text>{item.label}</Text>
            </View>
            <View style={styles.tbody}>
              <Text>{item.value}</Text>
            </View>
          </View>
        </Fragment>
      ))}
    </>
  );

  return (
    <Document>
      {charts.map((chart, i) => (
        <Page key={i} size="A4" style={styles.page}>
          <InvoiceTitle />
          <View style={styles.separator} />
          <Chart image={chart.image} type={chart.type} />
          <TableHead type={chart.type} />
          {/* <TableBody /> */}
          {TableBody(chart.data)}
        </Page>
      ))}
    </Document>
  );
};

export default Invoice;
